import { render, staticRenderFns } from "./AdvanceForm.vue?vue&type=template&id=22852b29"
import script from "./AdvanceForm.vue?vue&type=script&lang=js"
export * from "./AdvanceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports